import dayjs from "dayjs";
import React, { useState } from "react";
import { useLocation } from "react-router-dom";

export const RideByHourContext = React.createContext({
  activeTab: 1,
  setActiveTab: () => {},
  firstStepValues: {
    agentUser: "",
    hours: "",
    arrivalCity: "",
    arrivalDate: dayjs().add(3, "hours"),
    arrivalTime: dayjs().add(3, "hours"),
    location: "",
    locationCoords: "",
  },
  setFirstStepValues: () => {},
  secondStepValues: {
    vehicleType: "",
  },
  setSecondStepValues: () => {},
});

/**
 * The same as AirportRideContext, but to be used with the ride by hour instead of the airport
 *
 * @param {Object} props
 * @param {JSX.Element | JSX.Element[]} props.children - The elements inside the context provider
 * @returns {JSX.Element}
 */

export const RideByHourProvider = ({ children }) => {
  const { state } = useLocation();
  const [activeTab, setActiveTab] = useState(state ? 3 : 1);
  const [firstStepValues, setFirstStepValues] = useState({
    agentUser: state?.user || "",
    hours: state?.booking_hours || "",
    arrivalCity: state?.city || "",
    arrivalDate:
      state?.arrival_date && dayjs(state.arrival_date).isValid()
        ? dayjs(state.arrival_date)
        : null,
    arrivalTime: state?.arrival_time
      ? dayjs()
          .set("hours", state.arrival_time.split(":")[0])
          .set("minutes", state.arrival_time.split(":")[1])
      : null,
    location: state?.location || "",
    locationCoords:
      typeof state?.pick_up === "string"
        ? {
            lat: Number(state.pick_up.split(",")[0]),
            lng: Number(state.pick_up.split(",")[1]),
          }
        : null,
    zone: state?.zone || "",
  });
  const [secondStepValues, setSecondStepValues] = useState({
    vehicleType: state?.vehicle_type || "",
  });
  return (
    <RideByHourContext.Provider
      value={{
        activeTab,
        setActiveTab,
        firstStepValues,
        setFirstStepValues,
        secondStepValues,
        setSecondStepValues,
      }}
    >
      {children}
    </RideByHourContext.Provider>
  );
};
